import { events } from "../../js/state-machine";
import { prefix } from "../../js/utilities";
import { matchers } from "../../js/validate-props";

export const componentName = "Drawer";

export const defaultProps = Object.freeze({
    visible: false,
    width: undefined,
});

export const schema = Object.freeze({
    visible: matchers.boolean,
    width: matchers.or(matchers.undefined, matchers.string),
});

export const eventMap = Object.freeze({
    close: events.close(componentName),
    closed: events.closed(componentName),
    open: events.open(componentName),
    opened: events.opened(componentName),
});

export const componentClasses = Object.freeze({
    base: `${prefix}drawer`,
    container: `${prefix}drawer__container`,
    header: `${prefix}drawer__header`,
    body: `${prefix}drawer__body`,
    footer: `${prefix}drawer__footer`,
    close: `${prefix}drawer__close`,
    overlay: {
        base: `${prefix}drawer__overlay`,
        overflowHidden: `${prefix}drawer__overlay--overflow-hidden`,
    },
    sizes: {
        lg: "", // Default
        md: `${prefix}drawer--md`,
        sm: `${prefix}drawer--sm`,
        xs: `${prefix}drawer--xs`,
    },
});

export const views = Object.freeze({
    hidden: {
        attrs: { "aria-hidden": "true" },
    },
    visible: {
        attrs: { "aria-hidden": "false" },
    },
    body: {
        base: {
            classList: [`!${componentClasses.overlay.overflowHidden}`],
        },
        overflowHidden: {
            classList: [componentClasses.overlay.overflowHidden],
        },
    },
});
